import './App.css'
import { SupabaseProvider } from './contexts/SupabaseContext'
import { Outlet } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TourProvider } from './context/TourContext'


const queryClient = new QueryClient()

export default function App() {
  return (
    <TourProvider>
      <QueryClientProvider client={queryClient}>
        <SupabaseProvider>
          <div className="min-h-screen w-full bg-background overflow-hidden">
            <main className="w-full">
              <Outlet />
            </main>
          </div>
        </SupabaseProvider>
      </QueryClientProvider>
    </TourProvider>
  )
}
